import styled, { css } from 'styled-components';

interface ICreateAndEditTagContainerProps {
  isOnModal: boolean;
}

const CreateAndEditTagContainer = styled.div<ICreateAndEditTagContainerProps>`
  flex: 1;
  width: 100%;

  ${(props) =>
    props.isOnModal &&
    css`
      width: 80vw;
      height: 75vh;
      overflow-y: auto;
    `}
`;

export { CreateAndEditTagContainer };
